import React from "react";
import PlusComponent from "../../myComp/PlusComponent";
import PageGrid from "../../myComp/PageGrid";
import Loader from "../../myComp/Loader";

class ProjectGrid extends PlusComponent {
    constructor(props) {
      super(props, "project");
   
      this.state = {
        grid: null,
      };  
    }
   
    componentDidMount() {
      this.getGrid();
    }
    
    updateGrid(){
      this.getGrid();
    }

    render(){     
        return (
          <div className="main-content">
            <Loader visible={this.state.loadPanelVisible}></Loader>    
            <PageGrid title="Elenco Progetti" data={this.state.grid} controller="project" functionality="PROJECT" eventUpdate={this.updateGrid.bind(this)}></PageGrid>
          </div>
        );
    }     
}

export default ProjectGrid;